import { Component, Input, OnInit, OnDestroy, OnChanges, SimpleChanges, SimpleChange, ChangeDetectorRef } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs/Rx';
import { NetFacadeService } from '../../services/netfacade.service';
import { NavigationService, NavLocation, NavType } from '../../services/navigation.service';
import { DiscResultsService } from 'discovery';
import { IdentityService } from 'identity';
import { NetViewDto } from 'UvExplorerServer.Dtos.TS/NetViews';
import { AgentDto } from 'UvExplorerServer.Dtos.TS/Agents';
import { ScheduledDiscovery } from 'DiscoveryEngine.TS/Discovery';
import { ScheduledDiscoveryResultDto } from 'UvExplorerServer.Dtos.TS/Discovery';
import { List } from 'DiscoveryEngine.TS/Utils';
import { DateService } from 'base';
import { finalize } from 'rxjs/operators';


@Component({
    selector: 'discresult-list',
	templateUrl: './discresultlist.component.html',
	styleUrls: ['./discresultlist.component.scss']
})

export class DiscResultListComponent implements OnInit, OnDestroy {

	@Input()
	public discovery: ScheduledDiscovery;
	public get hasDiscovery(): boolean {
		return !!this.discovery;
	}

	public discResults: ScheduledDiscoveryResultDto[];

	private netViewTreeLoadedSub: Subscription;
	private netViewTreeChangedSub: Subscription;
	private netViewTreeUnloadedSub: Subscription;
	private sharesLoadedSub: Subscription;
	private sharesChangedSub: Subscription;
	private sharesUnloadedSub: Subscription;

	public displayDeleteResultConfirm: boolean = false;
	public displayDeleteAllResultsConfirm: boolean = false;

	constructor(
		private identityService: IdentityService,
		private netFacadeService: NetFacadeService,
		private navService: NavigationService,
		private discResultsService: DiscResultsService,
		private dateService: DateService,
		private changeDetector: ChangeDetectorRef) {

		this.discovery = null;
		this.discResults = [];

		this.netViewTreeLoadedSub = this.netFacadeService.onNetViewTreeLoaded.subscribe(() => {
			this.rebuildDiscResultList();
		});
		this.netViewTreeChangedSub = this.netFacadeService.onNetViewTreeChanged.subscribe(() => {
			this.rebuildDiscResultList();
		});
		this.netViewTreeUnloadedSub = this.netFacadeService.onNetViewTreeUnloaded.subscribe(() => {
			this.rebuildDiscResultList();
		});
		this.sharesLoadedSub = this.netFacadeService.onSharesLoaded.subscribe(() => {
			this.rebuildDiscResultList();
		});
		this.sharesChangedSub = this.netFacadeService.onSharesChanged.subscribe(() => {
			this.rebuildDiscResultList();
		});
		this.sharesUnloadedSub = this.netFacadeService.onSharesUnloaded.subscribe(() => {
			this.rebuildDiscResultList();
		});
    }

	public formatDateHm(date: string | Date): string {
		return this.dateService.formatDateHm(date);
	}

	public ngOnInit() {
		return;
	}

	public get isAdminValid(): boolean {
		return this.identityService.isAdmin;
	}

	public ngOnDestroy(): void {
		if (this.netViewTreeLoadedSub) {
			this.netViewTreeLoadedSub.unsubscribe();
			this.netViewTreeLoadedSub = undefined;
		}
		if (this.netViewTreeChangedSub) {
			this.netViewTreeChangedSub.unsubscribe();
			this.netViewTreeChangedSub = undefined;
		}
		if (this.netViewTreeUnloadedSub) {
			this.netViewTreeUnloadedSub.unsubscribe();
			this.netViewTreeUnloadedSub = undefined;
		}
		if (this.sharesLoadedSub) {
			this.sharesLoadedSub.unsubscribe();
			this.sharesLoadedSub = undefined;
		}
		if (this.sharesChangedSub) {
			this.sharesChangedSub.unsubscribe();
			this.sharesChangedSub = undefined;
		}
		if (this.sharesUnloadedSub) {
			this.sharesUnloadedSub.unsubscribe();
			this.sharesUnloadedSub = undefined;
		}
	}

	public ngOnChanges(changes: SimpleChanges): void {
		let change: SimpleChange = null;

		change = changes["discovery"];
		if (change) {
			this.rebuildDiscResultList();
		}
	}

	public onDiscResultClick(discResult: ScheduledDiscoveryResultDto): void {
		let agent: AgentDto = this.netFacadeService.findSchedDiscParent(this.discovery.GUID);

		let newNavLoc = new NavLocation(NavType.DiscResult);
		newNavLoc.netViewGuid = agent.ScopeGuid;
		newNavLoc.agentGuid = agent.Guid;
		newNavLoc.schedDiscGuid = this.discovery.GUID;
		newNavLoc.schedDiscRsltGuid = discResult.Guid;
		this.navService.selectLocation(newNavLoc);
	}

	public rebuildDiscResultList(): void {
		this.discResults = [];
		if (this.discovery) {
			this.discResultsService.getSchedDiscResults(this.discovery.GUID, "none").subscribe(
				(result: List<ScheduledDiscoveryResultDto>) => {
					this.discResults = [];
					result.ForEach((sdr: ScheduledDiscoveryResultDto) => {
						this.discResults.push(sdr);
					}, this);
					this.discResults.sort((a, b) => new Date(a.EndTime) < new Date(b.EndTime) ? 1 : -1);

					setTimeout(() => {
						this.changeDetector.detectChanges();
					}, 0);
				});
		}
	}

	private resultToDeleteGuid: string = "";

	public tryDeleteResult(event: any, resultGuid: string): void {
		event.stopPropagation();
		this.resultToDeleteGuid = resultGuid;
		this.displayDeleteResultConfirm = true;
	}

	public tryDeleteAllResults(event: any): void {
		event.stopPropagation();
		console.log(this.discovery.GUID);
		this.displayDeleteAllResultsConfirm = true;
	}

	public cancelDeleteResult(): void {
		this.resultToDeleteGuid = "";
		this.displayDeleteResultConfirm = false;
	}

	public cancelDeleteAllResults(): void {
		this.resultToDeleteGuid = "";
		this.displayDeleteAllResultsConfirm = false;
	}

	public deleteResult(): void {
		this.discResultsService.deleteSchedDiscResultByGuid(this.resultToDeleteGuid).subscribe({
			next: (result: boolean) => {
				this.resultToDeleteGuid = "";
				this.displayDeleteResultConfirm = false;
				this.rebuildDiscResultList();
			}
		});
	}

	public deleteAllResults(): void {
		this.discResultsService.deleteResultsForSchedDisc(this.discovery.GUID).subscribe({
			next: (result: boolean) => {
				this.resultToDeleteGuid = "";
				this.displayDeleteAllResultsConfirm = false;
				this.rebuildDiscResultList();
			}
		});
	}
}
